<p>
  add-hot-alert-dailog works!
</p>
